import React, { useState, useEffect, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { connect, useDispatch, useSelector } from 'react-redux';
import { claimRaised, claimRejected, claimResolved, claimPending, claimReceived, imageDisplay } from 'redux/actions/myClaims';
import styled from 'styled-components';
import Slider from 'react-slick';
import DropDown from 'web/components/DropDown';
import AlertModal from 'web/components/AlertModal';
import TrackDetailTypeOne from './TrackDetailTypeOne';
import TrackDetailTypeReceivedClaim from './TrackDetailTypeReceivedClaim';

import {
  orderUpdate, downloadOrderById, canceledOrder, canceledOrderListing, claimDispute, orderId, listAllOpenOrders, listAllDeliveredStatus, ratingUpdate
} from 'redux/actions/myOrders';

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Container } from './orderTabsStyled'
import { fetchLanguageContentNew } from 'redux/actions/language';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "transparent",
  },
  indicator: {
    background: "#2fb5f1",
  },

  AppBar: {
    backgroundColor: "transparent",
    color: "#000000",
    boxShadow: "none",
  },
  Tab: {
    textTransform: "capitalize",
    fontSize: "16px",
  },
}));

export default function SimpleTabs({ urlSearchParams }) {
  let history = useHistory();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  const [deliveableFlag, setDeliveableFlag] = useState(false);

  let userType = localStorage.getItem('userType');
  const accountType = localStorage.getItem('accountType')

  const [btnEnable, setBtnEnable] = useState(false)
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);
  let title = '';
  const [chatOpenOrderId, setChatOpenOrderId] = useState(null)
  const [response, setResponse] = useState(undefined);
  const [selectType, setSelectType] = useState(0);
  const [value, setValue] = React.useState(0);

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  useEffect(() => {
    if (languageContentNew?.Resolution_Center_Page) setPageLanguageContents(languageContentNew.Resolution_Center_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );

  // loader argument is for skip the loader gif when messaging is done (refresh with loader)
  const fetchApi = (val, loader) => {
    if (urlSearchParams.selectedTab === "RESOLVED" || val === "Resolved") {
      setDeliveableFlag(true)
      setResponse(undefined)
      setSelectType(2)
      if (accountType === "Seller" || accountType === "Buyer" || accountType === "Guest") setValue(1)
      else setValue(2)
      claimReceivedApi()
    } else if (urlSearchParams.selectedTab === "CLAIM_REJECTED" || val === "Rejected" || val === "Escalated") {
      setDeliveableFlag(true)
      setResponse(undefined)
      setSelectType(2)
      if (accountType === "Seller" || accountType === "Buyer" || accountType === "Guest") setValue(2)
      else setValue(3)
      if (loader === 'skipLoading') claimReceivedApi(loader)
      else claimReceivedApi()
    } else {
      if (urlSearchParams.selectedTab === "CLAIM_RAISED") {
        setDeliveableFlag(false)
        setResponse(undefined)
        setSelectType(0)
        setValue(0)
        if (accountType === "Seller") {
          pendingClaimApi()
        } else {
          claimRaisedApi()
        }
      } else if (urlSearchParams.selectedTab === "CLAIM_DETAILS") {
        setDeliveableFlag(true)
        setResponse(undefined)
        if (accountType === "Seller") {
          setSelectType(0)
          setValue(0)
        } else {
          setSelectType(1)
          setValue(1)
        }
        pendingClaimApi()
      } else {
        if (accountType === "Buyer") {
          setSelectType(0)
          claimRaisedApi()
        } if (accountType === "Seller") {
          setSelectType(1)
          pendingClaimApi()
        } else {
          if (selectType === 1) {
            pendingClaimApi()
          } else if (selectType === 2) {
            claimReceivedApi()
          } else {
            claimRaisedApi()
          }
        }
      }
    }
  }

  const [setTimer, setTimerState] = useState(false);
  useEffect(() => {
    fetchApi()
  }, []);

  const [canceledOrderResponse, setCanceledOrderResponse] = useState(undefined);
  const claimRaisedApi = async () => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      let response = await dispatch(claimRaised(token));

      if (response.status === 'SUCCESS') {
        if (response.payload.length !== 0) {
          setResponse(response.payload)
        } else {
          setTimeout(
            () => {
              if (response && response.payload.length === 0)
                setTimerState(true)
            },
            1000
          );
        }
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }
  const pendingClaimApi = async () => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      let response = await dispatch(claimPending(token));

      if (response.status === 'SUCCESS') {
        if (response.payload.length !== 0) {
          setResponse(response.payload)
        } else {
          setTimeout(
            () => {
              if (response && response.payload.length === 0)
                setTimerState(true)
            },
            1000
          );
        }
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }
  const claimRejectedApi = async () => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      let response = await dispatch(claimRejected(token));
      if (response.status === 'SUCCESS') {
        if (response.payload.length !== 0) {
          setResponse(response.payload)
        } else {
          setTimeout(
            () => {
              if (response && response.payload.length === 0)
                setTimerState(true)
            },
            1000
          );
        }
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }
  const claimReceivedApi = async (loader) => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      let response = await dispatch(claimResolved(token, loader));

      if (response.status === 'SUCCESS') {
        if (response.payload.length !== 0) {
          setResponse(response.payload)
          setTimeout(
            () => {
              if (response && response.length === 0)
                setTimerState(true)
            },
            4000
          );
        }
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }

  const imageDisplayApi = async (image) => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      let response = await dispatch(imageDisplay(image, token));
      if (response.status === 'SUCCESS') {
        if (response.payload.length !== 0) {
        }
      } else {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
    }
  }
  const classes = useStyles();


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const dropDownArr = [
    {
      id: '0',
      label: 'Last 1 month',
      value: '1',
    },
    {
      id: '1',
      label: 'Last 3 month',
      value: '3',
    },
    {
      id: '1',
      label: 'Last 6 months',
      value: '6',
    },
    {
      id: '1',
      label: 'Last 1 year',
      value: '12',
    },
    {
      id: '1',
      label: 'Last 2 year and above',
      value: '24',
    },
  ];

  return (
    <>
      <Container>
        <div className={classes.root}>
          <AppBar position="static" className={classes.AppBar}>
            {accountType === "Buyer" && (
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
                variant={"scrollable"}
                scrollButtons={"on"}
              >
                <Tab
                  label={pageLanguageContents?.TabHeadings[0]?.RaisedClaim}
                  {...a11yProps(0)}
                  onClick={() => {
                    setDeliveableFlag(false);
                    setResponse(undefined);
                    setSelectType(0);
                    claimRaisedApi();
                  }}
                />
                <Tab
                  label={pageLanguageContents?.TabHeadings[2]?.ResolvedClaims}
                  {...a11yProps(0)}
                  onClick={() => {
                    setDeliveableFlag(true);
                    setResponse(undefined);
                    setSelectType(2);
                    claimReceivedApi();
                  }}
                />
                <Tab
                  label='Escalated Claims'
                  {...a11yProps(selectType)}
                  onClick={() => {
                    setDeliveableFlag(true);
                    setResponse(undefined);
                    setSelectType(2);
                    claimReceivedApi();
                  }}
                />
              </Tabs>
            )}
            {accountType === "Seller" && (
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
                variant={"scrollable"}
                scrollButtons={"on"}
              >
                {/* Received Claim */}
                <Tab
                  label={pageLanguageContents?.TabHeadings[1]?.ReceivedClaims}
                  {...a11yProps(selectType)}
                  onClick={() => {
                    setDeliveableFlag(true);
                    setResponse(undefined);
                    setSelectType(1);
                    pendingClaimApi();
                  }}
                />
                <Tab
                  label={pageLanguageContents?.TabHeadings[2]?.ResolvedClaims}
                  {...a11yProps(0)}
                  onClick={() => {
                    setDeliveableFlag(true);
                    setResponse(undefined);
                    setSelectType(2);
                    claimReceivedApi();
                  }}
                />
                <Tab
                  label='Escalated Claims'
                  {...a11yProps(selectType)}
                  onClick={() => {
                    setDeliveableFlag(true);
                    setResponse(undefined);
                    setSelectType(2);
                    claimReceivedApi();
                  }}
                />
              </Tabs>
            )}
            {accountType === "Reseller" && (
              <>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="simple tabs example"
                  variant={"scrollable"}
                  scrollButtons={"on"}
                >
                  <Tab
                    label={pageLanguageContents?.TabHeadings[0]?.RaisedClaim}
                    {...a11yProps(selectType)}
                    onClick={() => {
                      setDeliveableFlag(false);
                      setResponse(undefined);
                      setSelectType(0);
                      claimRaisedApi();
                    }}
                  />
                  <Tab
                    label={pageLanguageContents?.TabHeadings[1]?.ReceivedClaims}
                    {...a11yProps(selectType)}
                    onClick={() => {
                      setDeliveableFlag(true);
                      setResponse(undefined);
                      setSelectType(1);
                      pendingClaimApi();
                    }}
                  />
                  <Tab
                    label={pageLanguageContents?.TabHeadings[2]?.ResolvedClaims}
                    {...a11yProps(selectType)}
                    onClick={() => {
                      setDeliveableFlag(true);
                      setResponse(undefined);
                      setSelectType(2);
                      claimReceivedApi();
                    }}
                  />
                  <Tab
                    label='Escalated Claims'
                    {...a11yProps(selectType)}
                    onClick={() => {
                      setDeliveableFlag(true);
                      setResponse(undefined);
                      setSelectType(2);
                      claimReceivedApi();
                    }}
                  />
                </Tabs>
              </>
            )}

            {(accountType === "Both" || accountType === "Guest") && (
              <>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="simple tabs example"
                  variant={"scrollable"}
                  scrollButtons={"on"}
                >
                  <Tab
                    label={pageLanguageContents?.TabHeadings[0]?.RaisedClaim}
                    {...a11yProps(selectType)}
                    onClick={() => {
                      setDeliveableFlag(false);
                      setResponse(undefined);
                      setSelectType(0);
                      claimRaisedApi();
                    }}
                  />
                  <Tab
                    label={pageLanguageContents?.TabHeadings[1]?.ReceivedClaims}
                    {...a11yProps(selectType)}
                    onClick={() => {
                      setDeliveableFlag(true);
                      setResponse(undefined);
                      setSelectType(1);
                      pendingClaimApi();
                    }}
                  />
                  <Tab
                    label={pageLanguageContents?.TabHeadings[2]?.ResolvedClaims}
                    {...a11yProps(selectType)}
                    onClick={() => {
                      setDeliveableFlag(true);
                      setResponse(undefined);
                      setSelectType(2);
                      claimReceivedApi();
                    }}
                  />
                  <Tab
                    label='Escalated Claims'
                    {...a11yProps(selectType)}
                    onClick={() => {
                      setDeliveableFlag(true);
                      setResponse(undefined);
                      setSelectType(2);
                      claimReceivedApi();
                    }}
                  />
                </Tabs>
              </>
            )}
          </AppBar>
          {accountType === "Buyer" && (
            <>
              <TabPanel value={value} index={0}>
                {response ? (
                  <TrackDetailTypeOne
                    response={response}
                    claimType="raiseClaim"
                    callBackFun={() => {
                      fetchApi();
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>}
                  </>
                )}
              </TabPanel>
              <TabPanel value={value} index={1}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response.filter(data => data.claimStatus != "REJECTED")}
                    claimType="receivedClaim"
                    callBackFun={() => {
                      fetchApi();
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && (
                      <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>
                    )}
                  </>
                )}
              </TabPanel>
              <TabPanel value={value} index={2}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response.filter(data => data.claimStatus === "REJECTED")}
                    claimType="receivedClaim"
                    chatOpenOrderId={chatOpenOrderId}
                    callBackFun={(val, orderId, loader) => {
                      fetchApi(val, loader);
                      setChatOpenOrderId(orderId)
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && (
                      <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>
                    )}
                  </>
                )}
              </TabPanel>
            </>
          )}
          {accountType === "Seller" && (
            <>
              <TabPanel value={value} index={0}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response}
                    claimType="pendingClaim"
                    callBackFun={(val) => {
                      fetchApi(val);
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && (
                      <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>
                    )}
                  </>
                )}
              </TabPanel>
              <TabPanel value={value} index={1}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response.filter(data => data.claimStatus != "REJECTED")}
                    claimType="receivedClaim"
                    callBackFun={() => {
                      fetchApi();
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>}
                  </>
                )}
              </TabPanel>
              <TabPanel value={value} index={2}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response.filter(data => data.claimStatus === "REJECTED")}
                    claimType="receivedClaim"
                    chatOpenOrderId={chatOpenOrderId}
                    callBackFun={(val, orderId, loader) => {
                      fetchApi(val, loader);
                      setChatOpenOrderId(orderId)
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && (
                      <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>
                    )}
                  </>
                )}
              </TabPanel>
            </>
          )}

          {accountType === "Reseller" && (
            <>
              <TabPanel value={value} index={0}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response}
                    claimType="raiseClaim"
                    callBackFun={() => {
                      fetchApi();
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && (
                      <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>
                    )}
                  </>
                )}
              </TabPanel>
              <TabPanel value={value} index={1}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response}
                    claimType="pendingClaim"
                    callBackFun={(val) => {
                      fetchApi(val);
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && (
                      <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>
                    )}
                  </>
                )}
              </TabPanel>
              <TabPanel value={value} index={2}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response.filter(data => data.claimStatus != "REJECTED")}
                    claimType="receivedClaim"
                    callBackFun={() => {
                      fetchApi();
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && (
                      <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>
                    )}
                  </>
                )}
              </TabPanel>
              <TabPanel value={value} index={3}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response.filter(data => data.claimStatus === "REJECTED")}
                    claimType="receivedClaim"
                    chatOpenOrderId={chatOpenOrderId}
                    callBackFun={(val, orderId, loader) => {
                      fetchApi(val, loader);
                      setChatOpenOrderId(orderId)
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && (
                      <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>
                    )}
                  </>
                )}
              </TabPanel>
            </>
          )}
          {(accountType === "Both" || accountType === "Guest") && (
            <>
              <TabPanel value={value} index={0}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response}
                    claimType="raiseClaim"
                    callBackFun={() => {
                      fetchApi();
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && (
                      <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>
                    )}
                  </>
                )}
              </TabPanel>
              <TabPanel value={value} index={1}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response}
                    claimType="pendingClaim"
                    callBackFun={(val) => {
                      fetchApi(val);
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && (
                      <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>
                    )}
                  </>
                )}
              </TabPanel>
              <TabPanel value={value} index={2}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response.filter(data => data.claimStatus != "REJECTED")}
                    claimType="receivedClaim"
                    callBackFun={() => {
                      fetchApi();
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && (
                      <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>
                    )}
                  </>
                )}
              </TabPanel>
              <TabPanel value={value} index={3}>
                {response ? (
                  <TrackDetailTypeOne
                    accountType={accountType}
                    response={response.filter(data => data.claimStatus === "REJECTED")}
                    claimType="receivedClaim"
                    chatOpenOrderId={chatOpenOrderId}
                    callBackFun={(val, orderId, loader) => {
                      fetchApi(val, loader);
                      setChatOpenOrderId(orderId)
                    }}
                    btnEnable={btnEnable}
                  />
                ) : (
                  <>
                    {setTimer && (
                      <NoRecordFound>{pageLanguageContents?.TabHeadings[3]?.NoRecord}</NoRecordFound>
                    )}
                  </>
                )}
              </TabPanel>
            </>
          )}
        </div>
      </Container>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </>
  );
}
const NoRecordFound = styled.div`
    text-align: center;
    margin-right: '400px';
    background: white;
`